var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage74({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 5v3.75H15m1.25-5-5 5M5 11.25h3.75V15m-5 1.25 5-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage74);
export default __webpack_public_path__ + "static/media/image74.8a3912096f14791083049224cc324125.svg";
export { ForwardRef as ReactComponent };